export const requestIdleCallback = (fn: () => void, options?: IdleRequestOptions): number =>
  'requestIdleCallback' in window
    ? window.requestIdleCallback(fn, options)
    : // @ts-ignore: 앞의 조건문으로 인해 window가 never로 인식됨.
      window.setTimeout(fn, 1);

export const cancelIdleCallback = (timerId: number) => {
  'cancelIdleCallback' in window
    ? window.cancelIdleCallback(timerId)
    : // @ts-ignore: 앞의 조건문으로 인해 window가 never로 인식됨.
      window.clearTimeout(timerId);
};
